import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import { App } from './app/app';
import { queryClient } from './lib/query-client';
import './styles/globals.css';

const container = document.getElementById('root');
if (!container) throw new Error('root 要素が見つかりません');

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      <Toaster
        position="top-center"
        // モノトーン方針に合わせ、色ではなく文字とアイコンで区別する
        toastOptions={{
          classNames: {
            toast: 'bg-surface-raised border border-border-strong text-foreground shadow-dialog',
            description: 'text-foreground-muted',
            actionButton: 'bg-primary text-primary-foreground',
          },
        }}
      />
    </QueryClientProvider>
  </StrictMode>,
);
